export const DELIVERY_MODAL_TEST_ID = 'delivery-welcome-screen';
export const S2O_MODAL_TEST_ID = 'scan-2-order-screen';
